document.addEventListener("DOMContentLoaded", function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function afterUpdate() {
    if (
      window.Globo &&
      window.Globo.Preorder &&
      window.Globo.Preorder.initialize
    ) {
      window.Globo.Preorder.initialize();
      updateBadges();
    }

    if (window.innerWidth > 768) {
      var params = new URLSearchParams(window.location.search);
      var paramVitems = params.get("vitems");

      if (!params.has("vitems") || paramVitems == "grid") {
        $(".templateSelectorList").removeClass("active");
        $(".templateSelectorGrid").addClass("active");
      }
    }
    //Change filters SVG on mobile
    var mySVG = $(".mz-action-bar .mz-filter svg");
    var myPath = $(".mz-action-bar .mz-filter svg path");
    if (mySVG.attr("viewBox") != "0 0 24 24") {
      mySVG.attr("viewBox", "0 0 24 24");
      myPath.attr(
        "d",
        "M20.5 5H8.82a3 3 0 1 0 0 2H20.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5M6 7a1 1 0 1 1 1-1 1 1 0 0 1-1 1m14.5 4h-5.68a3 3 0 0 0-5.64 0H3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5.68a3 3 0 0 0 5.64 0h5.68a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5M12 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1m6 2a3 3 0 0 0-2.82 2H3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11.68A3 3 0 1 0 18 15m0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1",
      );

      mySVG.after("<span class='mz-filter-text'>Filtre</span>");
    }

    //Filter explanation tooltip
    setFilterExplanationIcons();

    $(".mz-action-bar").on("click", function () {
      setFilterExplanationIcons();
    });

    //Product compare
    window.compareGridRender();

    //Product reviews
    if (window.judgeme.customizeBadges) {
      window.judgeme.customizeBadges();
    }
    if (window.zooomyColl) {
      window.zooomyColl($);
      $(".zoomywishid").css("display", "block");
    }
  }

  function setFilterExplanationIcons() {
    let facetElements = document.querySelectorAll(".mz-facet .mz-label");

    facetElements.forEach((facet, index) => {
      let facetName = facet.parentNode.getAttribute("data-facet-name");
      if (
        document.getElementById("filterDialog_modal_" + facetName) &&
        facet.querySelectorAll(".filtersDialogBtn").length == 0
      ) {
        facet.innerHTML +=
          "<a href='#' class='filtersDialogBtn' data-dialog-id='filterDialog_" +
          facetName +
          "'><svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width=1.5 stroke='currentColor' className='size-6'><path strokeLinecap='round' strokeLinejoin='round' d='m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z' /></svg></a>";
      }
    });

    $(document).ready(function () {
      $(".filtersDialogBtn").on("click", function (e) {
        e.preventDefault();

        var dialog = $(
          "[data-dialog='" + $(this).attr("data-dialog-id") + "']",
        );
        var closeButton = document.querySelector(
          "[data-dialog='" + $(this).attr("data-dialog-id") + "'] .closeModal",
        );
        closeButton.addEventListener("click", () => {
          dialog[0].close();
        });

        dialog[0].showModal();
      });
    });
  }

  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on("after-update", afterUpdate);
  }

  // Call updateBadges on initial page load
  updateBadges();
});

/* ----------------------------------------- */
function updateBadges() {
  // Get metaobjects from session
  const sessionData = sessionStorage.getItem("store");
  if (!sessionData) {
    return;
  }
  
  const session = JSON.parse(sessionData);
  const metaobjects = session?.data?.metaobjects?.nodes || [];

  // Make sure we are on collection or search page
  if (theme.pageType !== "collection" && theme.pageType !== "page") return;

  // Get all product > badge wrappers
  let badgeWrappers = document.querySelectorAll("article .mm-badges-wrapper");
  if (!badgeWrappers || badgeWrappers.length === 0) {
    return;
  }

  // Loop through each badge wrapper
  badgeWrappers.forEach((wrapper, index) => {
    let tags = wrapper.dataset.productTags;
    if (typeof tags === "undefined" || tags === "") return;

    // create array from tags
    tags = tags.split(",");
    tags.forEach((tag) => {
      // Trim whitespace from tag
      tag = tag.trim();
      
      if (tag.includes("giftcard_all_2026")) {
        // Get product price from the badge wrapper data attribute
        let priceInEuros = parseInt(wrapper.getAttribute("data-product-price")) || 0;
        
        // Calculate badge text based on price
        const hundredsSpent = Math.floor(priceInEuros / 100);
        let badgeText = "";
        
        if (priceInEuros < 800) {
                  badgeText = "Carte cadeau " + hundredsSpent * 10 + "€";
                } else {
                  badgeText = "Carte cadeau " + hundredsSpent * 20 + "€";
                }
        
        // Check if badge already exists to prevent duplication
        const existingBadges = wrapper.querySelectorAll(".mm-badge-label");
        const badgeAlreadyExists = Array.from(existingBadges).some(
          (badge) => badge.textContent === badgeText
        );
        
        if (!badgeAlreadyExists) {
          // Create new badge element
          const newBadge = document.createElement("div");
          newBadge.className = "mm-badge";
          newBadge.setAttribute("data-giftcard-badge", "true");
          
          // Create badge text element
          const badgeTextEl = document.createElement("span");
          badgeTextEl.className = "mm-badge-label";
          badgeTextEl.title = badgeText;
          badgeTextEl.textContent = badgeText;
          
          // Add badge inner element
          newBadge.appendChild(badgeTextEl);
          wrapper.appendChild(newBadge);
        }
      }      
      if (tag.includes("condition")) {
        const result = metaobjects.find((obj) =>
          obj.fields.some((field) => field.value.includes(tag)),
        );

        if (!result) return;

        const metaObject = result["fields"].reduce((obj, item) => {
          obj[item.key] = item.value;
          return obj;
        }, {});

        let isActiveCampaign = false;
        const showBadge = metaObject.add_badge_to_product_picture;

        // If the campaign has a start and end date, check if it is active
        if (metaObject.promotion_start_date && metaObject.promotion_end_date) {
          const currentDate = new Date();
          const startDate = new Date(metaObject.promotion_start_date);
          const endDate = new Date(metaObject.promotion_end_date);
          isActiveCampaign = currentDate >= startDate && currentDate <= endDate;
        } else {
          // If the campaign has no start and end date, it is always active
          isActiveCampaign = true;
        }

        // If the campaign is not active or the badge should not be shown, return / do nothing

        if (isActiveCampaign == true && showBadge == "true") {
          const newBadge = document.createElement("div");
          newBadge.className = "mm-badge";
          // Create badge text element
          const badgeText = document.createElement("span");
          badgeText.className = "mm-badge-label";
          badgeText.title = metaObject.badge;
          badgeText.textContent = metaObject.badge;
          // Add badge inner element
          newBadge.appendChild(badgeText);
          wrapper.appendChild(newBadge);
        }
      }
      if (tag.includes("badge")) {
        // console.log(tag)
      }
    });
  });
}
